import API_BASE_URL from "../utils/config";
import request from "../utils/request";


export async function httpGetQuizathonList(data) {
  const url = `${API_BASE_URL}/quizathon`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpGetQuizathonLeaderBoard(data) {
  const url = `${API_BASE_URL}/quizathon/leaderboard`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpGetSingleQuizathon(id) {
  const url = `${API_BASE_URL}/quizathon/${id}`;
  return request({
    url,
    method: "get",
  });
}
export async function httpGetQuizathonParticipants(data) {
  const url = `${API_BASE_URL}/quizathon/particpant`;
  return request({
    url,
    method: "get",
    data,
  });
}
export async function httpSingleParticipants(id) {
  const url = `${API_BASE_URL}/quizathon/particpant/${id}`;
  return request({
    url,
    method: "get",
  });
}
export async function httpCreateQuizathon(data) {
    const url = `${API_BASE_URL}/quizathon`;
    return request({
      url,
      method: "post",
      data,
    });
  }
export async function httpEditQuizathon(data) {
    const { id, ...editData } = data;
    const url = `${API_BASE_URL}/quizathon/${id}`;
    return request({
      url,
      method: "put",
      data: editData,
    });
  }
  export async function httpDeleteQuizathon(id) {
    const url = `${API_BASE_URL}/quizathon/${id}`;
    return request({
      url,
      method: "delete",
    });
  }
  